var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymbolOnDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137.54 232.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.39,179.41h0l-1.92,13.36L0,227.62l.6,1.21,51.25,.15c1.19-8.18-4.51-15.78-12.7-16.91l-3.02-.42c-4.55-.62-4.85-1.23-4.22-6.08L61.61,.08l-27.38-.08L8.39,179.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.04,182.69h0l1.86,13.37,3.45,35.28,.91,1,49.28-14.07c-1.12-8.19-8.71-13.91-16.89-12.73l-3.02,.44c-4.54,.67-5,.17-5.74-4.67l-18.61-132.47-26.32,7.52,15.08,106.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolOnDark);
export default __webpack_public_path__ + "static/media/symbol-on-dark.0d22c6f620ee7391e764a6c1a45681f3.svg";
export { ForwardRef as ReactComponent };